import {toast, ToastOptions} from "react-toastify";

const toastGeneralProps: ToastOptions = {
    autoClose: 10000,
    position: "top-center",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored"
}

export const ToastError = (errorMessage: string) => {
    toast.error(errorMessage, toastGeneralProps);
}

export const ToastWarning = (warningMessage: string) => {
    toast.warning(warningMessage, {...toastGeneralProps});
}

export const ToastInfo = (infoMessage: string) => {
    toast.info(infoMessage, {...toastGeneralProps});
}

export const ToastSuccess = (successMessage: string, customOptions?: ToastOptions) => {
    toast.success(successMessage, {...toastGeneralProps, ...customOptions});
}